/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */

import { AxiosResponse } from 'axios';

import { pathOr, clone, omit } from 'rambda';

import {
  PurchaseItemInterface,
  // TransactionsItemInterface,
} from '@/interfaces/purchaseItemTypes';
import { defineModule } from 'direct-vuex';
import { modActionCtx, modGetterCtx } from '@/store/index';
import { api } from '@/utils/apiInstance';

import { basicAdapterFetch, State } from '@/store/storeUtils';
import { INIT, PENDING, FULFILLED } from '@/utils/statuses';

import debounce from 'debounce';
import authCookies from '@/utils/cookies/authCookies';

export type PurchasesResponse = AxiosResponse<{ data: PurchaseItemInterface }>;

export interface PurchasesStateInterface {
  data: PurchaseItemInterface[];
  fetchState: State;
  canFetchMore: boolean;
  offset: number;
  limit: number;

  filters: {
    timestamp?: {
      start: number;
      end: number;
    };
    tx_type?: 'withdraw' | 'refill' | '';
    currency?: string;
    type?: string;
  };
}

const initialState: PurchasesStateInterface = {
  data: [],
  fetchState: INIT,

  canFetchMore: false,
  offset: 0,
  limit: 25,

  filters: {
    tx_type: '',
    currency: '',
    type: '',
  },
};

const purchasesStore = defineModule({
  namespaced: true,
  state: clone(initialState),

  getters: {
    fetchMoreState(...args): State {
      const { state } = getterCtx(args);

      if (state.data.length > 0) {
        return state.fetchState;
      }
      return FULFILLED;
    },
    fetchState(...args): State {
      const { state } = getterCtx(args);

      if (state.data.length <= 0) {
        return state.fetchState;
      }
      return FULFILLED;
    },
  },
  mutations: {
    CLEAR_STORE(state) {
      Object.assign(state, clone(initialState));
    },
    PREPARE_FOR_FIRST_FETCH(state) {
      Object.assign(state, omit(['filters'], initialState));
    },
    SET_STATE(state, { fetchState, data }: { fetchState: State; data: PurchasesResponse }) {
      state.fetchState = fetchState;

      const response: number = pathOr(1, ['data', 'code'], data);

      if (response === 0) {
        const list = pathOr([], ['data', 'data', 'records'], data);

        state.canFetchMore = list.length >= state.limit;

        state.data = [...state.data, ...list];
      }
    },
    SET_INIT(state) {
      state.fetchState = INIT;
    },
    SET_FILTERS(state, { filters }: { filters: PurchasesStateInterface['filters'] }) {
      state.filters = filters;
    },
    PREPARE_FOR_FILTERS(state) {
      Object.assign(state, clone(omit(['filters'], initialState)));
    },
    SET_OFFSET(state, offset: number) {
      state.offset = offset;
    },
  },
  actions: {
    async createReq(ctx) {
      const { commit, state } = actionCtx(ctx);

      await basicAdapterFetch({
        method: api.office.sendPost,
        props: {
          url: '/transaction/listMarketplace',
          data: {
            token: authCookies.get(),
            request: JSON.stringify({
              cmd: 'get',
              offset: state.offset,
              limit: state.limit,
              sort: [{
                field: 'mdate',
                direction: 'desc',
              }],
              // filter: state.filters,
            }),
          },
        },
        setState: commit.SET_STATE,
        callback: (fetchState) => {
          if (fetchState === FULFILLED) {
            commit.SET_OFFSET(state.data.length);
          }
        },
      });
    },

    async fetch(ctx, props: { fromZero?: boolean }) {
      const { commit, state, dispatch } = actionCtx(ctx);

      if (state.fetchState === PENDING) {
        return;
      }

      if (props.fromZero) {
        commit.PREPARE_FOR_FIRST_FETCH();
      }

      await dispatch.createReq();
    },

    changeFilters: (() => {
      const debouncedFetch = debounce((func: any) => {
        func();
      }, 500);

      return (ctx: any, filters: PurchasesStateInterface['filters']) => {
        const {
          commit,
          //  state,
          dispatch,
        } = actionCtx(ctx);

        // if (state.fetchState === PENDING) {
        //   return;
        // }

        commit.SET_FILTERS({ filters });
        debouncedFetch(() => {
          commit.PREPARE_FOR_FILTERS();
          dispatch.createReq();
        });
      };
    })(),
  },
});

export default purchasesStore;
const getterCtx = (args: [any, any, any, any]) => modGetterCtx(args, purchasesStore);
const actionCtx = (ctx: any) => modActionCtx(ctx, purchasesStore);
